import React, { useEffect, useState, useContext, useRef } from "react";
import Col from "../../../UIcomponent/Column";
import "./TeachersFilter.scss";
import LocalContext from "../../../Context/LocalContetxt";
import { ThemeContext } from "styled-components";
import Modal from "../../../UIcomponent/Modal";
import Text from "../../../UIcomponent/Text";
// import Svg from '../../../UIcomponent/Svg'
import StyledInput from "../../../UIcomponent/Input";
// import SearchIcon from '../../../Assets/icon/searchIcon.png'
// import CloseIcon from '../../../Assets/icon/closeIcon.png'
import { PublicDic } from "../../../Utility/PublicDic";
import Confirm from "../../../UIcomponent/Confirm";
import CustomSlider from "./CustomSlider";
import filter from "../../../Assets/icon/filter.svg";
// import sort from '../../../Assets/icon/sort.png'
import Image from "../../../UIcomponent/Image";
import TeachersListDic from "../TeachersListDic";
import TeachersListReq from "../../../Utility/Requester/TeachersListReq";
import { SearchCategory } from "./FilterList";
import FilterItem from "./FilterItem";
import { StyledModal } from "../../../UIcomponent/StyledModal";
// import { Notify } from '../../../UIcomponent/NotificationManager'
// import { OutSideClick } from '../../../Utility/Method/OutSideClick'
const TeachersFilter = (props) => {
  const {
    state,
    setState,
    setNoItemFound,
    getList,
    setParams,
    params,
    initialParams,
    removeFilter,
  } = props;
  const [subShow, setSubShow] = useState(false);
  const [searchCategory, setSearchCategory] = useState(SearchCategory);
  const [notificationMode, setNotificationMode] = React.useState(
    window.notificationOpen !== true
  );
  const [filterState, setFilterState] = useState({
    activeFilter: state.activeFilter,
    sliderValue: [50, 150],
    hasPriceFilter: false,
    hasQueryFilter: false,
    hasSortFilter: false,
    query: null,
    loading: {
      modalSubmit: false,
    },
    show: {
      priceSlider: false,
      filterMoadal: false,
    },
  });
  const filterWrapper = useRef();
  const theme = useContext(ThemeContext);
  const lang = useContext(LocalContext).lang;
  const FilterBar = useRef();

  function onNotificationCollapse() {
    setNotificationMode(false);
  }

  React.useEffect((_) => {
    document.addEventListener("notificationCollapsed", onNotificationCollapse);
    return (_) =>
      document.removeEventListener(
        "notificationCollapsed",
        onNotificationCollapse
      );
  }, []);

  const SubCategoryHandler = (i) => {
    if (subShow === false) {
      setSubShow(true);
    }
    let newSearchCategory = [...searchCategory];
    newSearchCategory = newSearchCategory.map((cat, index) => {
      return {
        ...cat,
        show: index === i ? true : false,
      };
    });
    setSearchCategory(newSearchCategory);
  };
  const HideSub = () => {
    setSubShow(false);
    let newSearchCategory = [...searchCategory];
    newSearchCategory = newSearchCategory.map((cat, index) => {
      return {
        ...cat,
        show: false,
      };
    });
    setSearchCategory(newSearchCategory);
  };
  const SubStatusHandler = (i, type) => {
    setSubShow(false);
    let newSearchCategory = [...searchCategory];
    newSearchCategory = newSearchCategory.map((cat, index) => {
      return {
        ...cat,
        show: false,
        active: i === index ? type : cat.active,
      };
    });

    setSearchCategory(newSearchCategory);
  };
  const OutSideClick = (e, FilterBar) => {
    if (FilterBar && FilterBar.current) {
      if (!FilterBar.current.contains(e.target)) {
        HideSub();
      }
    }
  };
  // const showPriceSliderHandler = (e, v) => {
  //     setFilterState({
  //         ...filterState,
  //         show: {
  //             ...filterState.show,
  //             priceSlider: !filterState.show.priceSlider
  //         }
  //     })
  // }
  const cancelPrice = () => {
    let Params = {
      ...initialParams,
    };
    Params.SortingBy = "";
    Params.SortingOrder = params.SortingOrder;
    setParams(Params);
    getList(Params);
    SubStatusHandler(1, false);
    setFilterState({
      ...filterState,
      hasPriceFilter: false,
      show: {
        ...filterState.show,
        priceSlider: false,
      },
    });
  };
  const cancelSort = () => {
    let Params = {
      ...initialParams,
      MinPrice:
        state.hasPriceFilter === true ? filterState.sliderValue[0] * 10000 : 0,
      MaxPrice:
        state.hasPriceFilter === true
          ? filterState.sliderValue[1] * 10000
          : 200 * 10000,
      sortBy: "recently",
      sortOrder: 1,
    };
    getList(Params);
    SubStatusHandler(0, false);
    setFilterState({
      ...filterState,
      hasSortFilter: false,
      show: {
        ...filterState.show,
        priceSlider: false,
      },
    });
  };
  const confirmPriceSlider = () => {
    let Params = { ...params };
    Params.QUERY = state.query || null;
    Params.SortingBy = filterState.activeFilter;
    Params.SortingBy = "price";
    Params.SortingOrder = params.SortingOrder;
    Params.MinPrice = filterState.sliderValue[0] * 10000;
    Params.MaxPrice = filterState.sliderValue[1] * 10000;
    Params.Page = 0;
    Params.PageSize = 10;
    TeachersListReq.FindTeacher(Params)
      .then((res) => {
        let Results = [];
        if (res.data.Results !== null) {
          Results = res.data.Results.map((each) => {
            return {
              ...each,
              tab: 0,
            };
          });
          setState({
            ...state,
            Results,
            hasPriceFilter: true,
            Paging: res.data.Paging,
          });
          setParams(Params);
          setNoItemFound(false);
        } else {
          HideSub();
          setNoItemFound(true);
        }
        SubStatusHandler(1, true);
      })
      .catch((err) => {});
  };
  const showFilterModalHandler = () => {
    setFilterState({
      ...filterState,
      show: {
        ...filterState.show,
        filterMoadal: true,
      },
    });
  };
  const cancelFilterModal = () => {
    setFilterState({
      ...filterState,
      show: {
        ...filterState.show,
        filterMoadal: false,
      },
    });
  };
  /* --- Teachers Filter --- */
  const SortHanlder = (type) => {
    setState({
      ...state,
      activeFilter: type,
    });
  };
  const confirmSort = (type) => {
    let Params = { ...params };
    if (type === "lowest price") {
      Params.SortingBy = "price";
      Params.SortingOrder = 2;
    } else if (type === "highest price") {
      Params.SortingBy = "price";
      Params.SortingOrder = 1;
    } else if (type === "recently") {
      Params.SortingBy = "";
      Params.SortingOrder = 1;
    } else {
      Params.SortingBy = type;
      Params.SortingOrder = 1;
    }
    Params.MinPrice =
      state.hasPriceFilter === true ? filterState.sliderValue[0] * 10000 : 0;
    Params.MaxPrice =
      state.hasPriceFilter === true
        ? filterState.sliderValue[1] * 10000
        : 200 * 10000;
    TeachersListReq.FindTeacher(Params)
      .then((res) => {
        let Results = [];
        if (res.data !== null) {
          Results = res.data.Results.map((each) => {
            return {
              ...each,
              tab: 0,
            };
          });
          setState({
            ...state,
            Results,
            params,
            hasSortFilter: true,
            Paging: res.data.Paging,
          });
          setNoItemFound(false);
        } else {
          HideSub();
          setNoItemFound(true);
        }
        setParams(Params);
        SubStatusHandler(0, true);
      })
      .catch((err) => {});
  };
  const ModalSortHanlder = (type) => {
    if (type === "lowest price") {
      setParams({
        ...params,
        SortingBy: "price",
        SortingOrder: 2,
      });
    } else if (type === "highest price") {
      setParams({
        ...params,
        SortingBy: "price",
        SortingOrder: 1,
      });
    } else {
      setParams({
        ...params,
        SortingBy: "",
        SortingOrder: 2,
      });
    }
    setFilterState({
      ...filterState,
      activeFilter: type,
    });
  };

  /* --- Teachers Price Filter Change --- */
  const setSliderValue = (value) => {
    setFilterState({
      ...filterState,
      sliderValue: value,
    });
  };
  //    filterState.show.filterMoadal ? searchRef.current.value = 'refVal' : null

  /* --- Teachers Search --- */
  // const SearchSubmit = (e) => {
  //   e.preventDefault();
  //   let query = searchRef.current.value;
  //   params.QUERY = query;
  //   params.SortingBy = filterState.activeFilter;
  //   let sortBy = filterState.activeFilter === "highest price" ? 2 : 1;
  //   params.SortingOrder = sortBy;
  //   params.MinPrice = filterState.sliderValue[0];
  //   params.MaxPrice = filterState.sliderValue[1];
  //   params.Page = 0;
  //   params.PageSize = 3;
  //   TeachersListReq.FindTeacher(params)
  //     .then((res) => {
  //       let Results;
  //       if (res.data.Results) {
  //         Results = res.data.Results.map((each) => {
  //           return {
  //             ...each,
  //             tab: 0,
  //           };
  //         });
  //       } else {
  //         Results = [];
  //       }
  //       setState({
  //         ...state,
  //         query,
  //         params,
  //         Results,
  //         Paging: { ...state.Paging, ...res.data.Paging },
  //       });
  //       searchRef.current.value = query;
  //     })
  //     .catch((err) => {});
  // };
  // const removeSearchCurrentQuery = () => {
  //   params.QUERY = null;
  //   TeachersListReq.FindTeacher(params)
  //     .then((res) => {
  //       let Results;
  //       if (res.data.Results) {
  //         Results = res.data.Results.map((each) => {
  //           return {
  //             ...each,
  //             tab: 0,
  //           };
  //         });
  //       } else {
  //         Results = [];
  //       }
  //       setState({
  //         ...state,
  //         query: null,
  //         params,
  //         Results,
  //         Paging: { ...state.Paging, ...res.data.Paging },
  //       });
  //       searchRef.current.value = null;
  //     })
  //     .catch((err) => {});
  // };
  /* --- Modal Pramas Handler  --- */
  // const removeModalSearchCurrentQuery = () => {
  //     setParams({
  //         ...params,
  //         QUERY: ''
  //     })
  //     setFilterState({
  //         ...filterState,
  //         hasQueryFilter: false
  //     })
  // }
  const confirmFilterModal = () => {
    let Params = { ...params };
    Params.QUERY = params.QUERY;
    Params.SortingBy = params.SortingBy;
    Params.MinPrice = filterState.sliderValue[0] * 10000;
    Params.MaxPrice = filterState.sliderValue[1] * 10000;
    TeachersListReq.FindTeacher(Params).then((res) => {
      let Results = [];
      if (res.data.Results !== null) {
        Results = res.data.Results.map((each) => {
          return {
            ...each,
            tab: 0,
          };
        });
        setParams(Params);
      } else {
        setNoItemFound(true);
      }
      setState({
        ...state,
        activeFilter: filterState.activeFilter,
        Results,
        Paging: res.data.Paging,
      });
      setFilterState({
        ...filterState,
        hasQueryFilter: Params.QUERY === "" ? false : true,
        show: {
          ...filterState.show,
          filterMoadal: false,
        },
      });
    });
  };
  const resetFilterModal = () => {
    setTimeout(() => {
      removeFilter();
    }, 0);
    setTimeout(() => {
      setParams(initialParams);
      setFilterState({
        ...filterState,
        activeFilter: "recently",
        sliderValue: [50, 150],
        hasPriceFilter: false,
        hasQueryFilter: false,
        hasSortFilter: false,
        show: {
          ...filterState.show,
          filterMoadal: false,
        },
      });
    }, 1);
  };
  const inputChange = (e) => {
    let val = e.target.value;
    setParams({
      ...params,
      QUERY: val,
    });
  };
  useEffect(() => {}, [params]);
  return (
    <>
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className={`${
          subShow === true && "c__SubCategoryBackground--Show"
        } c__SubCategoryBackground`}
        innerRef={filterWrapper}
        onClick={(e) => OutSideClick(e, FilterBar)}
        // height='auto'
      >
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          lang={lang}
          className={`c__TeachersFilter ${
            notificationMode ? "notificationMode" : ""
          }`}
          innerRef={FilterBar}
        >
          <Col
            className="c__SearchCategory"
            xl={11.5}
            lg={11}
            md={11}
            sm={16}
            xs={0}
          >
            {searchCategory.map((each, i) => {
              return (
                <Col
                  style={{
                    width: "auto",
                    margin: "0px 0px 0px 15px",
                  }}
                >
                  <Col className="o__SearchCategory">
                    <Col
                      className={`o__SearchCategory__Name ${
                        each.active === true &&
                        "o__SearchCategory__Name--Active"
                      }`}
                      onClick={() => SubCategoryHandler(i)}
                    >
                      {each.name}
                    </Col>
                    <Confirm
                      lang={lang}
                      top="60px"
                      className={`${
                        each.show === true && "c__SearchSubCategory--Show"
                      } c__SearchSubCategory `}
                      okText={PublicDic.confirm[`${lang}`]}
                      cancelText={"حذف"}
                      onCancel={i === 0 ? cancelSort : cancelPrice}
                      onConfirm={
                        i === 0
                          ? () => confirmSort(state.activeFilter)
                          : confirmPriceSlider
                      }
                    >
                      {i === 0 ? (
                        <Col
                          xl={24}
                          lg={24}
                          md={24}
                          sm={17}
                          xs={18}
                          className="c__TeachersFilter__Sort__Item"
                        >
                          <FilterItem
                            item={each.SubCategoryList}
                            type={each.subType}
                            onSelect={SortHanlder}
                            activeFilter={state.activeFilter}
                            deletableSort={true}
                            onDeselect={() => SortHanlder("recently")}
                          />
                        </Col>
                      ) : (
                        <Col
                          position="relative"
                          className="c__TeachersFilter__Price"
                        >
                          <Col
                            className="o__TeachersFilter__Price__Slider"
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                          >
                            <CustomSlider
                              min={0}
                              max={200}
                              defaultValue={filterState.sliderValue}
                              sliderValue={filterState.sliderValue}
                              onChangeHandler={setSliderValue}
                              step={5}
                            />
                          </Col>
                          <Col
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className="o__TeachersFilter__Price__MinMax"
                          >
                            {` از  ${filterState.sliderValue[0]} هزار تومان   تا ${filterState.sliderValue[1]} هزار تومان`}
                            {/* <Col
                                                                    xl={12} lg={12} md={12} sm={12} xs={12}
                                                                >
                                                                    {filterState.sliderValue[0]} هزار تومان
                                                            </Col>
                                                                <Col
                                                                    xl={12} lg={12} md={12} sm={12} xs={12}
                                                                >
                                                                    {filterState.sliderValue[1]} هزار تومان
                                                            </Col> */}
                          </Col>
                        </Col>
                      )}
                    </Confirm>
                  </Col>
                </Col>
              );
            })}
          </Col>
          <Col
            className="c__TeachersFilter__Sort"
            xl={11.5}
            lg={11}
            md={11}
            sm={16}
            xs={0}
            justifyContent="flex-start"
          ></Col>
          <Col sm={11} xs={11} className="c__TeachersFilter__Title--RES">
            {TeachersListDic.Title[`${lang}`]}
          </Col>
          <Col sm={11} xs={11} className="c__TeachersFilter__Filter--RES">
            <Col
              onClick={showFilterModalHandler}
              className="o__TeachersFilter__Filter--RES"
            >
              <Image src={filter} />
              <Text>فیلتر</Text>
            </Col>
          </Col>
        </Col>
      </Col>
      <StyledModal
        visible={filterState.show.filterMoadal}
        okType={theme.secondary}
        hasWrapper
        key={"filterModal"}
        lang={"fa"}
        modalTitle="فیلتر"
        FooterActionText="جستجو"
        headerActionTitle="حذف فیلتر"
        headerActionHandler={resetFilterModal}
        onClose={cancelFilterModal}
        confirmHandler={confirmFilterModal}
      >
        <Col
          sm={21}
          xs={21}
          style={{
            flexDirection: "column",
          }}
        >
          <Col sm={24} xs={24} className="c__TeachersFilter__Search--RES">
            <Col sm={24} xs={24} className="o__TeachersFilter__Search--RES">
              <form
                style={{
                  padding: "0px 0px 0px 0px",
                  width: "100%",
                }}
                onSubmit={(e) => {
                  e.preventDefault();
                  confirmFilterModal();
                }}
              >
                <StyledInput
                  onChange={inputChange}
                  value={params.QUERY}
                  type="search"
                  placeholder="جستجو"
                  lang={lang}
                  disable={filterState.hasQueryFilter}
                  style={{
                    border: "none",
                  }}
                />
                {/* {params.QUERY === '' ?
                                <Image
                                    className='searchFilterIcon'
                                    src={SearchIcon} />
                                :
                                <Image
                                    onClick={removeModalSearchCurrentQuery}
                                    className='removeSearchFilterIcon'
                                    src={CloseIcon} />
                            } */}
              </form>
            </Col>
          </Col>
          <Col sm={24} xs={24} className="c__TeachersFilter__Price--RES">
            <Col
              sm={24}
              xs={24}
              className="o__TeachersFilter__Price__Title--RES"
            >
              قیمت
            </Col>
            <Col sm={24} xs={24} className="o__TeachersFilter__Price--RES">
              <CustomSlider
                min={0}
                max={200}
                // width={250}
                defaultValue={filterState.sliderValue}
                sliderValue={filterState.sliderValue}
                // setSliderValue={setSliderValue}
                onChangeHandler={setSliderValue}
                step={5}
              />
            </Col>
          </Col>
          <Col sm={24} xs={24} className="c__TeachersFilter__Price__Box--RES">
            <Col sm={10} xs={10} className="o__TeachersFilter__Price__Box--RES">
              {filterState.sliderValue[1]} هزار تومان
            </Col>
            <Col sm={10} xs={10} className="o__TeachersFilter__Price__Box--RES">
              {filterState.sliderValue[0]} هزار تومان
            </Col>
          </Col>
          <Col sm={24} xs={24} className="c__TeachersFilter__Sort--RES">
            <Col
              sm={24}
              xs={24}
              className="o__TeachersFilter__Sort__Title--RES"
            >
              مرتب سازی
            </Col>
            <Col className="o__TeachersFilter__Sort--RES">
              <Col className="c__TeachersFilter__Sort__Item--RES">
                <FilterItem
                  // onSelect={SortHanlder}
                  // activeFilter={state.activeFilter}
                  // deletableSort={true}
                  onDeselect={() => ModalSortHanlder("recently")}
                  onSelect={ModalSortHanlder}
                  activeFilter={filterState.activeFilter}
                  deletableSort={false}
                  // unSelect={ModalSortUnselect}
                />
              </Col>
            </Col>
          </Col>
        </Col>
      </StyledModal>
    </>
  );
};

export default TeachersFilter;
